/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_ClaimingInputs */



/**
* | output |
* | --- |
* | "Claiming..." |
*
* @param {Profile_ClaimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_claiming = /** @type {((inputs?: Profile_ClaimingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_ClaimingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Revendication...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reclamando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reivindicando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reclamo...")
	return /** @type {LocalizedString} */ ("Claiming...")
});